import React from "react";

const TopArrow = () => {
  return (
    <svg
      className="animate-bounce"
      xmlns="http://www.w3.org/2000/svg"
      width="22.243"
      height="15.621"
      viewBox="0 0 38.243 31.621"
    >
      <path
        id="chevron-left-arrow"
        d="M25,4,8,21,25,38"
        transform="translate(40.121 4.5) rotate(90)"
        fill="none"
        stroke="#cecece"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        id="chevron-left-arrow-2"
        data-name="chevron-left-arrow"
        d="M25,4,8,21,25,38"
        transform="translate(40.121 -6.5) rotate(90)"
        fill="none"
        stroke="#707070"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  );
};

export default TopArrow;
